import '../scss/vendors.scss';
import '../scss/main.scss';

import { appConfig } from './app.config.js';
import { appRunSettings } from './app.run.js';

const modules = [
	'ngRoute',
	'textAngular',
	'ui.bootstrap',
	'ngCookies',
	'dndLists',
	'colorpicker.module',
	'ngPatternRestrict',
	'ngIntercom'
];
const analyticsModules = [
	'angulartics',
	'angulartics.google.tagmanager',
	'angulartics.google.analytics'
];

const requires = [];

export let isModuleMissed = false;

const isIE =
	navigator.userAgent.indexOf('MSIE ') > -1 ||
	navigator.userAgent.indexOf('Trident/') > -1;
const safariVersion = getSafariVersion();
const isNotSupportedBrowser =
	safariVersion < 9 || !Modernizr.flexbox || !Modernizr.sizes;

if (!isNotSupportedBrowser && !isIE) {
	analyticsModules.forEach(checkIfModuleAvaible);

	angular
		.module('main', getRequiresArray())
		.config(appConfig)
		.run(appRunSettings);
} else {
	showUnsupportedBrowserPage();
}

function showUnsupportedBrowserPage() {
	angular
		.module('unsupportedBrowser', [])
		.controller('UnsupportedBrowserController', [
			'$scope',
			UnsupportedBrowserController
		])
		.component('snApp', {
			template: `
        <section ng-hide="isIE9" class="unsupported-browser bg-white">
    <div class="container">
        <div class="row flex-row flex-just-center">
            <div class="col-xs-12 col-sm-10 col-lg-9 flex-row flex-wrap-xs unsupported-browser__box">
                <div class="ps-15 unsupported-browser__image">
                    <img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/non_supported_browser.png">
                </div>
                <p class="ps-15">Sorry, your browser is not supported. For a better experience, please view this link in the latest version of <a href="https://www.google.com/chrome/browser/desktop/index.html">Chrome</a>, <a href="https://www.mozilla.org/en-US/firefox/new/"
                >Firefox</a> or <a href="https://support.apple.com/downloads/safari">Safari</a>.</p>
            </div>
        </div>
    </div>
</section>
      `,
			controllerAs: 'vm',
			controller: UnsupportedBrowserController
		});

	angular.element(document).ready(() => {
		angular.bootstrap(document.body, ['unsupportedBrowser']);
	});
}

function getSafariVersion() {
	const ua = navigator.userAgent;
	const tem = ua.match(/version\/(\d+)/i);
	let M =
		ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
		[];
	if (M[2]) {
		M = [M[1], M[2]];
	} else {
		M = [navigator.appName, navigator.appVersion, '-?'];
	}
	if (tem != null) {
		M.splice(1, 1, tem[1]);
	}
	if (M[0] === 'Safari') {
		return parseInt(M[1]);
	}
	return 1000;
}

function checkIfModuleAvaible(moduleName) {
	try {
		angular.module(moduleName);
		requires.push(moduleName);
	} catch (error) {
		isModuleMissed = true;
	}
}

function getRequiresArray() {
	return modules.concat(requires);
}

function UnsupportedBrowserController($scope) {
	$scope.adBlockEnabled = false;

	const msie = navigator.userAgent.indexOf('MSIE ');
	if (msie > 0) {
		$scope.isIE9 =
			parseInt(
				navigator.userAgent.substring(
					msie + 5,
					navigator.userAgent.indexOf('.', msie)
				)
			) === 9;
	}
}



// WEBPACK FOOTER //
// ./web/js/app.js